/*
 * JARS Filter: reine Logik ohne DOM (URL lesen/schreiben, Filtern, Zählen, Sortieren, Seiten).
 * Ersetzt die App „Smart Product Filter & Search“ (Globo). URL-Format bewusst identisch zur App:
 *   ?gf_<Options-ID>=<Wert>   Leerzeichen als „+“, mehrere Werte derselben Option = Parameter wiederholt (ODER),
 *   Preis als „min:max“, dazu sort_by, limit, page.
 * Werte mit Zuordnung („114mm - 119mm = Klingenlänge 114 116 117 118 119“) filtern wie die Wertegruppen der App
 * (Bastian 09.10.2026: 1:1 wie heute). Die Etikett-Regel („114mm - 119mm“, „bis 90mm“, „ab 151mm“) gilt nur noch für
 * Werte ohne Zuordnung, z. B. Hand-Links mit früheren Etiketten.
 * Testbar mit Node: _migration/werkzeuge/filter-logik-test.mjs
 */
(function (global) {
  'use strict';

  // „Klingenlänge: 114mm“, „KLingenlänge: 180mm“, „Grifflänge:108mm“ → { schluessel: 'klingenlänge', wert: 114 }
  function tagLesen(tag) {
    const m = String(tag).match(/^\s*([^:]+?)\s*:\s*(.+?)\s*$/);
    if (!m) return null;
    const schluessel = m[1].toLowerCase().replace(/\s+/g, ' ');
    const zahl = m[2].match(/^(\d+(?:[.,]\d+)?)\s*mm$/i);
    return { schluessel, text: m[2], zahl: zahl ? parseFloat(zahl[1].replace(',', '.')) : null };
  }

  // Bereich aus einem Etikett: „114mm - 119mm“, „bis 90mm“, „ab 151mm“. Liefert null, wenn nicht lesbar.
  function bereichLesen(wert) {
    const t = String(wert).replace(/\s+/g, ' ').trim().toLowerCase();
    let m = t.match(/^(\d+(?:[.,]\d+)?) ?mm ?- ?(\d+(?:[.,]\d+)?) ?mm$/);
    if (m) return { von: parseFloat(m[1].replace(',', '.')), bis: parseFloat(m[2].replace(',', '.')) };
    m = t.match(/^bis (\d+(?:[.,]\d+)?) ?mm$/);
    if (m) return { von: -Infinity, bis: parseFloat(m[1].replace(',', '.')) };
    m = t.match(/^ab (\d+(?:[.,]\d+)?) ?mm$/);
    if (m) return { von: parseFloat(m[1].replace(',', '.')), bis: Infinity };
    return null;
  }

  const norm = s => String(s).replace(/\s+/g, ' ').trim().toLowerCase();

  // Wertezeilen des Editors: „Etikett = Schlüssel Zahl Zahl …“ (Wertegruppe wie in der App) oder nur „Etikett“ (Etikett-Regel)
  function werteLesen(text) {
    return String(text || '').split(/\r?\n/).map(z => z.trim()).filter(Boolean).map(z => {
      const i = z.indexOf('=');
      if (i < 0) return { wert: z, gruppe: null };
      const m = z.slice(i + 1).trim().match(/^(.*?[^\d\s.,])\s+([\d.,\s]+)$/);
      const zahlen = m ? m[2].trim().split(/\s+/).map(x => parseFloat(x.replace(',', '.'))).filter(x => !isNaN(x)) : [];
      return { wert: z.slice(0, i).trim(), gruppe: zahlen.length ? { schluessel: norm(m[1]), zahlen } : null };
    });
  }

  // Längen aus der Produktbeschreibung: „handle = Klingenlänge 101, Grifflänge 115“ → { handle: { klingenlänge: [101], grifflänge: [115] } }
  function zusatzLesen(text) {
    const aus = {};
    for (const z of String(text || '').split(/\r?\n/)) {
      const i = z.indexOf('=');
      const handle = i < 0 ? '' : z.slice(0, i).trim();
      if (!handle) continue;
      for (const teil of z.slice(i + 1).split(',')) {
        const m = teil.trim().match(/^(.*?[^\d\s.,])\s+(\d+(?:[.,]\d+)?)$/);
        if (!m) continue;
        const k = norm(m[1]);
        aus[handle] = aus[handle] || {};
        (aus[handle][k] = aus[handle][k] || []).push(parseFloat(m[2].replace(',', '.')));
      }
    }
    return aus;
  }

  // URL-Parameter → Zustand. optionen: [{ id, typ: 'preis'|'bereich'|'liste', ... }]
  function zustandAusUrl(suche, optionen) {
    const p = new URLSearchParams(suche);
    const auswahl = {};
    let preis = null;
    for (const o of optionen) {
      const werte = p.getAll('gf_' + o.id).map(w => w.trim()).filter(Boolean);
      if (o.typ === 'preis') {
        const m = (werte[0] || '').match(/^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/);
        if (m) preis = { min: parseFloat(m[1]), max: parseFloat(m[2]) };
      } else if (werte.length) auswahl[o.id] = [...new Set(werte)];
    }
    const limit = parseInt(p.get('limit'), 10);
    const seite = parseInt(p.get('page'), 10);
    return {
      auswahl, preis,
      sortierung: p.get('sort_by') || '',
      // Die App nahm jede Zahl an (gemessen limit=7 und limit=100); Obergrenze 250 wie eine Shopify-Seite
      limit: limit > 0 ? Math.min(limit, 250) : 0,
      seite: seite > 0 ? seite : 1,
      suche: (p.get('q') || '').trim(),
    };
  }

  // Adress-Parameter genau wie die App (globo.filter.min.js, Fassung 1120, am 07.10.2026 gelesen und nachgemessen).
  // Die App hält alle Parameter in einem einfachen Objekt, dessen Schlüssel-Reihenfolge die Reihenfolge in der Adresse ist:
  // zuerst die Filter (Kennungen als Zahl, dadurch aufsteigend; Werte in Wahl-Reihenfolge), dann sort_by (von Anfang an
  // vorhanden), dann alle übrigen Schlüssel in der Reihenfolge, in der sie zuerst in der Adresse standen oder gesetzt wurden.
  // Werte bleiben roh (Leerzeichen, Doppelte, unbekannte Kennungen), page=1 und die Standardsortierung fallen weg, # auch.
  // ponytail: gff_-Parameter (Fahrzeugsuche der App) werden wie fremde behandelt, JARS hat keine
  const APP_INTERN = ['filter_id', 'market_id', 'shop', 'collection', 'vendor', 'type', 'event', 'currentTags', 'excludeTags', 'currency', 'country', 'cache', 'locale', 'form_id', 'company_location_id', 'company_location_country', 'catalog_ids', 'cid', 'did', 'page_type'];
  function parameterAusUrl(suche, standardSortierung) {
    const p = { sort_by: standardSortierung };
    const u = new URLSearchParams(suche), x = {};
    for (const [k] of u) if (!Object.prototype.hasOwnProperty.call(x, k)) { const alle = u.getAll(k); x[k] = alle.length === 1 ? alle[0] : alle; }
    for (const k of Object.keys(x)) {
      const v = x[k];
      if (v === '') continue;
      if (k.startsWith('gf_')) {
        const id = k.slice(3);
        (p.filter = p.filter || {})[/^\d+$/.test(id) && +id > 0 ? parseInt(id, 10) : id] = [].concat(v);
      } else p[k] = k === 'sort_by' ? (/^[A-Za-z0-9._-]{1,64}$/.test(String(v)) ? String(v) : '') : v;
    }
    return p;
  }
  // ohne: ein Schlüssel, der wegbleibt (die App baut Seitenlinks als Adresse ohne page + „page=N“ am Ende)
  function urlAusParametern(p, standardSortierung, ohne) {
    const t = new URLSearchParams();
    for (const id of Object.keys(p.filter || {})) for (const w of [].concat(p.filter[id])) t.append('gf_' + id, w);
    for (const k of Object.keys(p)) {
      if (k === 'filter' || k === ohne || APP_INTERN.includes(k)) continue;
      if (k === 'page' && p[k] == 1) continue; // lose Gleichheit wie die App: "1" und 1
      if (k === 'sort_by' && p[k] === standardSortierung) continue;
      t.append(k, p[k]);
    }
    const s = t.toString();
    return s ? '?' + s : '';
  }
  // Jede Filter-, Sortier-, Anzahl- und Suchänderung der App löscht page, aber nur wenn > 1 (sonst bleibt der Schlüssel an seinem Platz)
  function seiteZuruecksetzen(p) {
    if (Object.prototype.hasOwnProperty.call(p, 'page') && p.page > 1) delete p.page;
  }

  // Produkt: { tags: [...], preise: [Euro je Variante], ... }. Prüft eine Option gegen eine Werteliste (ODER).
  // Unlesbare Bereichswerte und Listenwerte, die bei keinem Produkt vorkommen, werden ignoriert: ein defekter oder
  // veralteter Link zeigt dann alle Produkte statt einer leeren Seite.
  function passtOption(produkt, o, werte) {
    if (!werte || !werte.length) return true;
    if (o.typ === 'bereich') {
      // Wert mit Zuordnung: Tag-Zahlen der Gruppe (auch eines anderen Schlüssels, wie bei der App); sonst Bereich aus dem Etikett
      const regeln = werte.map(w => (o._gruppen && o._gruppen.get(norm(w))) || ((b) => b && { schluessel: o.schluessel, von: b.von, bis: b.bis })(bereichLesen(w))).filter(Boolean);
      if (!regeln.length) return true;
      return regeln.some(r => (produkt._werte[r.schluessel] || []).some(x => r.zahlen ? r.zahlen.includes(x) : x >= r.von && x <= r.bis));
    }
    if (o.typ === 'liste') {
      const bekannt = werte.map(norm).filter(w => o._bekannt && o._bekannt.has(w));
      if (!bekannt.length) return true;
      const vorhanden = produkt._listen[o.schluessel] || [];
      return bekannt.some(w => vorhanden.includes(w));
    }
    return true;
  }
  // Wie die alte App und Shopify: passt, sobald irgendeine Variante im Preisbereich liegt.
  const passtPreis = (produkt, preis) => !preis || (produkt.preise || [produkt.preis]).some(x => x >= preis.min && x <= preis.max);
  // Wie die App: jedes Suchwort muss am Anfang eines Wortes stehen („n690“ findet „n690h60“, „ager“ findet nichts).
  const wortAnfang = wort => new RegExp('(^|[^a-z0-9äöüß])' + wort.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const passtSuche = (produkt, q) => !q || norm(q).split(' ').every(wort => wortAnfang(wort).test(produkt._suchtext));

  // Bereitet Produkte einmalig auf (Tag-Werte je Option, Suchtext).
  // zusatz (optional, aus zusatzLesen): Längen aus der Beschreibung, nur wo das Produkt für diesen Schlüssel keinen Tag hat.
  function vorbereiten(produkte, optionen, zusatz) {
    const schluessel = new Set();
    for (const o of optionen) {
      if (o.typ === 'liste') o._bekannt = new Set();
      if (o.typ !== 'bereich') continue;
      schluessel.add(o.schluessel);
      o._gruppen = new Map();
      for (const w of o.werte || []) if (w && w.gruppe) { o._gruppen.set(norm(w.wert), w.gruppe); schluessel.add(w.gruppe.schluessel); }
    }
    for (const p of produkte) {
      p._werte = {}; p._listen = {};
      for (const tag of p.tags || []) {
        const t = tagLesen(tag);
        if (!t) continue;
        if (schluessel.has(t.schluessel) && t.zahl !== null) (p._werte[t.schluessel] = p._werte[t.schluessel] || []).push(t.zahl);
        for (const o of optionen) {
          if (o.typ === 'liste' && t.schluessel === o.schluessel) { (p._listen[o.schluessel] = p._listen[o.schluessel] || []).push(norm(tag)); o._bekannt.add(norm(tag)); }
        }
      }
      const z = zusatz && zusatz[p.handle];
      if (z) for (const k of Object.keys(z)) if (!p._werte[k]) p._werte[k] = z[k].slice();
      p._suchtext = norm([p.titel, p.hersteller, p.typ, ...(p.tags || [])].join(' '));
    }
    return produkte;
  }

  function filtern(produkte, optionen, z, ohneOption) {
    return produkte.filter(p => passtPreis(p, ohneOption === 'preis' ? null : z.preis) && passtSuche(p, z.suche) &&
      optionen.every(o => o.typ === 'preis' || o.id === ohneOption || passtOption(p, o, z.auswahl[o.id])));
  }

  // Anzahl je Wert einer Option unter allen übrigen aktiven Filtern (wie die App: Zahl in Klammern).
  function zaehlen(produkte, optionen, z, o) {
    const basis = filtern(produkte, optionen, z, o.id);
    const aus = {};
    for (const w of o.werte || []) aus[w.wert] = basis.filter(p => passtOption(p, o, [w.wert])).length;
    return aus;
  }

  // Reihenfolge, die als Gleichstand-Regel (p.index) gebraucht wird; an der App gemessen am 06.10.2026:
  //   Preis aufsteigend = kleinster Variantenpreis, bei Gleichstand Bestseller-Reihenfolge
  //   Preis absteigend  = größter Variantenpreis, bei Gleichstand neueste zuerst
  //   Verfügbarkeit     = verfügbare zuerst, dann neueste zuerst
  //   % Rabatt          = höchster Rabatt einer Variante zuerst, dann neueste zuerst
  // Alle übrigen Sortierungen liefert Shopify (Bestseller, Titel, Datum, Standard der Kollektion).
  function gleichstandNach(sortierung) {
    if (sortierung === 'price-ascending') return 'best-selling';
    if (['price-descending', 'stock-descending', 'sale-descending'].includes(sortierung)) return 'created-descending';
    return sortierung;
  }
  function sortieren(produkte, sortierung) {
    const a = produkte.slice();
    const stabil = (f) => a.sort((x, y) => f(x, y) || x.index - y.index);
    const preise = p => p.preise && p.preise.length ? p.preise : [p.preis];
    if (sortierung === 'sale-descending') stabil((x, y) => y.rabatt - x.rabatt);
    else if (sortierung === 'stock-descending') stabil((x, y) => (y.verfuegbar ? 1 : 0) - (x.verfuegbar ? 1 : 0));
    else if (sortierung === 'price-ascending') stabil((x, y) => Math.min(...preise(x)) - Math.min(...preise(y)));
    else if (sortierung === 'price-descending') stabil((x, y) => Math.max(...preise(y)) - Math.max(...preise(x)));
    else a.sort((x, y) => x.index - y.index);
    return a;
  }

  function seiten(produkte, limit, seite) {
    const proSeite = limit || 12;
    const anzahl = Math.max(1, Math.ceil(produkte.length / proSeite));
    const s = Math.min(Math.max(1, seite), anzahl);
    return { proSeite, anzahl, seite: s, liste: produkte.slice((s - 1) * proSeite, s * proSeite) };
  }

  global.JarsFilterLogik = { tagLesen, bereichLesen, werteLesen, zusatzLesen, zustandAusUrl, parameterAusUrl, urlAusParametern, seiteZuruecksetzen, vorbereiten, filtern, zaehlen, gleichstandNach, sortieren, seiten, passtOption, passtSuche };
})(typeof window !== 'undefined' ? window : globalThis);
